import React from "react";
import { Box, Link, Typography, Stack } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { config } from "../core/service/config.service";

const yesCase1 =
  "Yes, I have collaborator from Top 100 University Ranking or Subject Ranking.";
const yesCase2 = "Yes, I have collaborator from Top International Institute.";
const yesCase3 =
  "Yes, I have collaborator who is a high performance professor but not coming from Top 100 University";

const ConfirmationOutputSubmissionYes1 = (detail) => {
  if (detail.length === 0) return;
  const {
    collaboratorName,
    universityInstituteCollaborator,
    referenceWorldRankingStatus,
    worldRankingYear,
    noWorldRanking
  } = detail[0];

  return (
    <Box>
      <Stack direction="row" spacing={3} sx={{ paddingTop: 2 }}>
        <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
          Collaborator Name:
        </Typography>
        <Typography sx={{ paddingTop: 1 }}>{collaboratorName}</Typography>
      </Stack>

      <Stack direction="row" spacing={3}>
        <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
          University/Institute of Collaborator:
        </Typography>
        <Typography sx={{ paddingTop: 1 }}>
          {universityInstituteCollaborator}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={3}>
        <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
          Reference of World Ranking Status:
        </Typography>
        <Typography sx={{ paddingTop: 1 }}>
          {referenceWorldRankingStatus}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={12}
        variant="subtitle2"
        sx={{ paddingTop: 1 }}
      >
        <Typography variant="subtitle1">World Ranking Year:</Typography>
        <Typography>{worldRankingYear}</Typography>
        <Typography variant="subtitle1">No. of World Ranking:</Typography>
        <Typography>{noWorldRanking}</Typography>
      </Stack>
    </Box>
  );
};

const ConfirmationOutputSubmissionYes2 = (detail) => {
  if (detail.length === 0) return;
  const {
    collaboratorName,
    universityInstituteCollaborator,
    evidenceTopInternationalInstitute
  } = detail[0];

  return (
    <Box>
      <Stack direction="row" spacing={3} sx={{ paddingTop: 2 }}>
        <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
          Collaborator Name:
        </Typography>
        <Typography sx={{ paddingTop: 1 }}>{collaboratorName}</Typography>
      </Stack>

      <Stack direction="row" spacing={3}>
        <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
          University/Institute of Collaborator:
        </Typography>
        <Typography sx={{ paddingTop: 1 }}>
          {universityInstituteCollaborator}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={3} sx={{ paddingTop: 1 }}>
        <Typography variant="subtitle1">
          File Evidence of Top International Institute:
        </Typography>
        <Link
          href={
            evidenceTopInternationalInstitute
              ? `${config.host_api}download/${evidenceTopInternationalInstitute}`
              : null
          }
        >
          {evidenceTopInternationalInstitute?.split("-").pop() || " "}
        </Link>
        <DownloadIcon />
      </Stack>
    </Box>
  );
};

const ConfirmationOutputSubmissionYes3 = (detail) => {
  if (detail.length === 0) return;
  const {
    collaboratorName,
    universityInstituteCollaborator,
    evidenceHighPerformanceProfessor
  } = detail[0];

  return (
    <Box>
      <Stack direction="row" spacing={3} sx={{ paddingTop: 2 }}>
        <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
          Collaborator Name:
        </Typography>
        <Typography sx={{ paddingTop: 1 }}>{collaboratorName}</Typography>
      </Stack>

      <Stack direction="row" spacing={3}>
        <Typography variant="subtitle1" sx={{ paddingTop: 1 }}>
          University/Institute of Collaborator:
        </Typography>
        <Typography sx={{ paddingTop: 1 }}>
          {universityInstituteCollaborator}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={3} sx={{ paddingTop: 1 }}>
        <Typography variant="subtitle1">
          File Evidence of High Performance Professor:
        </Typography>
        <Link
          href={
            evidenceHighPerformanceProfessor
              ? `${config.host_api}download/${evidenceHighPerformanceProfessor}`
              : null
          }
        >
          {evidenceHighPerformanceProfessor?.split("-").pop() || " "}
        </Link>
        <DownloadIcon />
      </Stack>
    </Box>
  );
};

export default function ConfirmationOutputSubmissionModal({ detail }) {
  if (detail.length !== 0) {
    const { collaboratorFromTop100 } = detail[0];

    return (
      <>
        {collaboratorFromTop100 === yesCase1 &&
          ConfirmationOutputSubmissionYes1(detail || [])}
        {collaboratorFromTop100 === yesCase2 &&
          ConfirmationOutputSubmissionYes2(detail || [])}
        {collaboratorFromTop100 === yesCase3 &&
          ConfirmationOutputSubmissionYes3(detail || [])}
      </>
    );
  } else {
    return null;
  }
}
